/* 1119 - colour-aware product media.
   Marks every gallery item that does not belong to the selected colour, paints
   each colour option with that colour's own photo, and sequences the desktop
   grid as back / lifestyle / front / lifestyle.

   The phone carousel is deliberately NOT touched here: its slides have to be
   removed rather than hidden, and that is gta-pod-carousel.js, which reads the
   same data-gtap-hide mark this script writes.

   Everything is !important on purpose: the theme's stylesheets load from inside
   the sections, so they sit later in the document than this injected style. */
(function () {
  if (window.__gtapVariantMedia) return;
  window.__gtapVariantMedia = true;

  function readMap() {
    var tag = document.querySelector('[data-gtap-media-map]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  /* Flat supplier mockups are square; lifestyle shots are portrait. The width
     and height attributes are in the markup, so this works before load. */
  function isFlat(el) {
    var img = el.querySelector('img');
    if (!img) return null;
    var w = parseInt(img.getAttribute('width'), 10) || img.naturalWidth;
    var h = parseInt(img.getAttribute('height'), 10) || img.naturalHeight;
    if (!w || !h) return null;
    return w === h;
  }

  /* back, lifestyle, front, lifestyle - the supplier exports front then back,
     so the flats are reversed to lead with the print. CSS order is safe here:
     nothing reads the grid's positions, it is only laid out. */
  function orderIn(container) {
    if (!container) return;
    var flats = [], lifes = [], kids = container.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      el.style.order = '';
      if (el.hasAttribute('data-gtap-hide')) continue;
      var flat = isFlat(el);
      if (flat === null) return; /* sizes not known yet - a later pass will do it */
      (flat ? flats : lifes).push(el);
    }
    if (!flats.length && !lifes.length) return;
    flats.reverse();
    var n = Math.max(flats.length, lifes.length);
    for (var k = 0; k < n; k++) {
      if (flats[k]) flats[k].style.order = k * 2 + 1;
      if (lifes[k]) lifes[k].style.order = k * 2 + 2;
    }
  }

  function boot() {
    var cfg = readMap();
    if (!cfg) return;

    var option = cfg.option || 'Color';
    var media = cfg.media || {};
    var shots = cfg.shots || {};

    var style = document.createElement('style');
    var css = '[data-gtap-hide]{display:none !important;}';

    if (cfg.swatches) {
      var w = cfg.swatchWidth || 56;
      var lab = '.variant-option__button-label:has(input[data-option-name="' + option + '"])';
      var on = '.variant-option__button-label:has(input[data-option-name="' + option + '"]:checked)';
      var fill =
        'background-size:cover !important;' +
        'background-position:center !important;' +
        'background-repeat:no-repeat !important;';

      css +=
        '.variant-option--buttons:has(input[data-option-name="' + option + '"])' +
        '{grid-template-columns:repeat(auto-fill,' + w + 'px) !important;gap:8px !important;}' +
        lab + '{width:' + w + 'px !important;aspect-ratio:4/5 !important;' + fill +
        'background-color:#F4F4F2 !important;border:1px solid #E2E2E2 !important;' +
        'padding:0 !important;min-height:0 !important;overflow:hidden;}' +
        on + '{border:1px solid #0B0B0B !important;' +
        'box-shadow:inset 0 0 0 2px #0B0B0B;' + fill + '}' +
        lab + ' .variant-option__button-label__pill{display:none !important;}' +
        lab + ' .variant-option__button-label__text{position:absolute !important;' +
        'width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;}';

      Object.keys(shots).forEach(function (colour) {
        var sel = '[data-option-name="' + option + '"][value="' + colour.replace(/"/g, '\\"') + '"]';
        css +=
          '.variant-option__button-label:has(' + sel + ')' +
          '{background-image:url("' + shots[colour] + '") !important;}';
      });
    }

    style.textContent = css;
    document.head.appendChild(style);

    function selectedColour() {
      var inputs = document.querySelectorAll('input[data-option-name="' + option + '"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) return inputs[i].value;
      }
      return null;
    }

    function apply() {
      /* A product with a single colour renders no radio inputs at all, so there
         is nothing to read and nothing to hide. That must not stop the ordering:
         skipping it here is what left those products showing the plain front
         first instead of the print. */
      if (cfg.filter) {
        /* the block is re-rendered on every variant change, so re-read the map */
        var fresh = readMap();
        if (fresh && fresh.media) media = fresh.media;
        var colour = selectedColour();
        if (colour) {
          var nodes = document.querySelectorAll('[data-media-id]');
          for (var i = 0; i < nodes.length; i++) {
            var owner = media[nodes[i].dataset.mediaId];
            if (!owner) continue;
            /* mark the whole slot, not just the picture, so the grid closes up */
            var slot = nodes[i].closest('.product-media-container') || nodes[i];
            slot.toggleAttribute('data-gtap-hide', owner !== colour);
          }
        }
      }
      orderIn(document.querySelector('.media-gallery__grid'));
    }

    /* Timers, not requestAnimationFrame: rAF is frozen in a background tab, and
       a run that never fired used to leave the other colours' photos on screen. */
    var t = null;
    function schedule() {
      clearTimeout(t);
      t = setTimeout(apply, 40);
    }

    document.addEventListener('change', function (event) {
      var el = event.target;
      if (el && el.dataset && el.dataset.optionName === option) {
        schedule();
        setTimeout(apply, 300);
        setTimeout(apply, 900);
      }
    });

    /* Watch the document, not the product section: Horizon swaps that whole
       subtree out on a variant change, which orphaned the old observer. */
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      childList: true
    });

    /* The width/height attributes can still be missing on the very first pass,
       so re-run once the pictures have actually loaded. */
    window.addEventListener('load', apply);
    setTimeout(apply, 600);
    setTimeout(apply, 1500);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
